module.exports = __webpack_public_path__ + "media/images/iconSettings__inFrontOfAccent--dark-0cd934782fe384c8171cd6eda4748086.png";